
import React from 'react';

type Filters = {
  gender: string;
  smoker: string;
  failed: string;
  dateFrom: string;
  dateTo: string;
  search: string;
};

type Props = {
  filters: Filters;
  onFilterChange: (filters: Filters) => void;
};

export default function AdminFilters({ filters, onFilterChange }: Props) {
  const update = (key: keyof Filters, value: string) => {
    if (!filters) return;
    onFilterChange({ ...filters, [key]: value });
  };

  const hasActiveFilters =
    !!filters.gender ||
    !!filters.smoker ||
    !!filters.failed ||
    !!filters.dateFrom ||
    !!filters.dateTo ||
    !!filters.search;

  const clearAll = () => {
    onFilterChange({ gender: '', smoker: '', failed: '', dateFrom: '', dateTo: '', search: '' });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold text-gray-900 flex items-center gap-2">
          <i className="ri-filter-3-line text-teal-600"></i>
          Filtreler
        </h3>
        {hasActiveFilters && (
          <button type="button" onClick={clearAll}
            className="text-xs text-red-500 hover:text-red-600 font-medium cursor-pointer whitespace-nowrap">
            Temizle
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {/* Search */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Arama</label>
          <input
            type="text"
            value={filters.search}
            onChange={(e) => update('search', e.target.value)}
            placeholder="Hasta, klinik, marka..."
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none"
          />
        </div>

        {/* Gender */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Cinsiyet</label>
          <select
            value={filters.gender}
            onChange={(e) => update('gender', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none cursor-pointer"
          >
            <option value="">Tümü</option>
            <option value="e">Erkek</option>
            <option value="k">Kadın</option>
          </select>
        </div>

        {/* Smoker */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Sigara</label>
          <select
            value={filters.smoker}
            onChange={(e) => update('smoker', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none cursor-pointer"
          >
            <option value="">Tümü</option>
            <option value="yes">Kullanıyor</option>
            <option value="no">Kullanmıyor</option>
          </select>
        </div>

        {/* Fail Status */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Fail Durumu</label>
          <select
            value={filters.failed}
            onChange={(e) => update('failed', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none cursor-pointer"
          >
            <option value="">Tümü</option>
            <option value="has_fail">Fail Var</option>
            <option value="no_fail">Fail Yok</option>
          </select>
        </div>

        {/* Date From */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Başlangıç</label>
          <input
            type="date"
            value={filters.dateFrom}
            onChange={(e) => update('dateFrom', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none"
          />
        </div>

        {/* Date To */}
        <div>
          <label className="block text-xs text-gray-500 mb-1 font-medium">Bitiş</label>
          <input
            type="date"
            value={filters.dateTo}
            onChange={(e) => update('dateTo', e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none"
          />
        </div>
      </div>
    </div>
  );
}
